<ng-container *ngIf="dashboard">
	<div class="tp-box w-100" [@flipState]="flip">
		<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
			<div class="cw-wrap w-100" [ngStyle]="themeVars">
				<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
					<i class="material-icons">trending_up</i>
				</div>
				<div class="cw-header">
					<div class="cw-title-group">
						<span class="cw-title">{{ searchForm ? ('Top ' + (searchForm.get('limit').value || 25) + ' Items') : title }}</span>
					</div>
				</div>
				<div class="cw-body">
					<div class="dashboard-expanded-toolbar" *ngIf="searchForm">
						<mat-form-field appearance="outline" class="dashboard-location-field">
							<mat-label>Locations</mat-label>
							<mat-select [formControl]="searchForm.get('loccode')" (selectionChange)="onDashboardLocationChange()" [disabled]="locations.length <= 1" multiple>
								<mat-option *ngFor="let loc of locations" [value]="loc.loccode">{{ loc.locationname }}</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field appearance="outline" class="dashboard-date-field">
							<mat-label>Date From</mat-label>
							<input matInput [matDatepicker]="pickerFrom" [formControl]="searchForm.get('datefrom')" (dateChange)="onDashboardDateChange()" />
							<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
							<mat-datepicker #pickerFrom></mat-datepicker>
						</mat-form-field>
						<mat-form-field appearance="outline" class="dashboard-date-field">
							<mat-label>Date To</mat-label>
							<input matInput [matDatepicker]="pickerTo" [formControl]="searchForm.get('dateto')" (dateChange)="onDashboardDateChange()" />
							<mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
							<mat-datepicker #pickerTo></mat-datepicker>
						</mat-form-field>
						<mat-form-field appearance="outline" class="dashboard-limit-field">
							<mat-label>Limit</mat-label>
							<input matInput type="number" [formControl]="searchForm.get('limit')" (change)="onDashboardLimitChange()" min="1" max="500" />
						</mat-form-field>
						<button mat-raised-button color="accent" (click)="onDashboardLimitChange()" [disabled]="sending">
							<mat-icon>refresh</mat-icon>
							Refresh
						</button>
						<ng-container *ngIf="data && !sending">
							<button mat-raised-button class="btn-success me-2" (click)="exportXls()">
								<i class="fa fa-file-excel-o"></i> XLS
							</button>
							<button mat-raised-button color="warn" (click)="exportPdf()">
								<i class="fa fa-file-pdf-o"></i> PDF
							</button>
						</ng-container>
						<span *ngIf="sending">
							<svg class="spinner" width="35" height="35" viewBox="0 0 66 66">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" />
							</svg>
						</span>
					</div>
					<div class="table-responsive" #print_table>
						<table class="table table-striped table-bordered table-hover table-fixed">
							<thead>
								<tr>
									<th (click)="sortBy('stockid')">Item Number</th>
									<th (click)="sortBy('description')">Description</th>
									<th (click)="sortBy('salestotal')">Sales Total ($)</th>
									<th (click)="sortBy('qtytotal')">Sales Total (Qty)</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let r of sortedReportResults">
									<td>{{ r.stockid }}</td>
									<td>{{ r.description }}</td>
									<td>{{ r.salestotal | currency }}</td>
									<td>{{ r.qtytotal | number }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
			<div class="col-12 p-0">
				<app-dashboard-stat-card
					[title]="searchForm ? ('Top ' + (searchForm.get('limit').value || 25) + ' Items') : title"
					icon="trending_up"
					accent="danger"
					[value]="data ? data.length : null"
					[loading]="!data"
					(view)="toggleFlip(data, title)">
				</app-dashboard-stat-card>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="!dashboard && !menuapp">
	<form [formGroup]="searchForm" class="m-0 p-0">
		<div class="main_card m-0 p-0">
			<div class="row m-0 p-0">
				<div class="col-12">
					<h3> Top {{ this.searchForm.get('limit').value }} Items </h3>
				</div>
			</div>
			<div class="row m-0 p-0">
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline" class="amount-text">
						<mat-label>Limit</mat-label>
						<input matInput type="text" formControlName="limit" class="text-right " />
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Brands</mat-label>
						<mat-select formControlName="brand" multiple appSelectAll>
							<mat-option *ngFor="let v of brands" [value]="v.manufacturer_id">
								{{v.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Categories</mat-label>
						<mat-select formControlName="category" multiple appSelectAll>
							<mat-option *ngFor="let v of categories" [value]="v.categoryid">
								{{v.categoryid }} - {{v.categorydescription}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Product Lines</mat-label>
						<mat-select formControlName="prodline" multiple appSelectAll>
							<mat-option *ngFor="let v of productlines" [value]="v.line_field">
								{{v.line_description}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Date From</mat-label>
						<input matInput [matDatepicker]="pickerFrom" formControlName="datefrom">
						<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
						<mat-datepicker #pickerFrom></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline">
						<mat-label>Date To</mat-label>
						<input matInput [matDatepicker]="pickerTo" formControlName="dateto">
						<mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
						<mat-datepicker #pickerTo></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-xs-12 col-md-3 col-3">
					<span *ngIf="sending">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
					<div class="ActionButtons" *ngIf="!sending">
						<button mat-raised-button class="btn-success" (click)="$event.preventDefault();exportXls()">
							<i class="fa fa-file-excel-o"></i> XLS
						</button>
						<button mat-raised-button color="warn" (click)="$event.preventDefault();exportPdf()">
							<i class="fa fa-file-pdf-o"></i> PDF
						</button>
						<button mat-raised-button color="accent" (click)="tophundred()">
							<mat-icon>refresh</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>
	<div #print_table>
		<div class="table table-responsive text-center" *ngIf="loading">
			<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</div>
		<table class="table table-striped table-bordered table-hover table-fixed" *ngIf="!loading">
			<thead>
				<tr>
					<th (click)="sortBy('stockid')">Item Number</th>
					<th (click)="sortBy('description')">Description </th>
					<th (click)="sortBy('salestotal')">Sales Total ($) </th>
					<th (click)="sortBy('qtytotal')">Sales Total (Qty)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let r of sortedReportResults">
					<td>{{ r.stockid }}</td>
					<td>{{ r.description }}</td>
					<td>{{ r.salestotal | currency }}</td>
					<td>{{ r.qtytotal | number }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</ng-container>

<ng-container *ngIf="!dashboard && menuapp">
	<div class="main-content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="card">
						<div class="card-header card-header-{{color}}-6">
							<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Top {{ this.searchForm.get('limit').value }} Items</h4>
							<p class="card-category text-right"></p>
						</div>
						<div class="card-body">
							<form [formGroup]="searchForm" class="m-0 p-0">
								<div class="main_card m-0 p-0">
									<div class="row m-0 p-0">
										<div class="col-12">
											<h3> Top {{ this.searchForm.get('limit').value }} Items </h3>
										</div>
									</div>
									<div class="row m-0 p-0">
										<div class="col-xs-12 col-md-3 col-3">
											<mat-form-field appearance="outline" class="amount-text">
												<mat-label>Limit</mat-label>
												<input matInput type="text" formControlName="limit" class="text-right " />
											</mat-form-field>
										</div>
										<div class="col-xs-12 col-md-3 col-3">
											<mat-form-field appearance="outline">
												<mat-label>Brands</mat-label>
												<mat-select formControlName="brand" multiple appSelectAll>
													<mat-option *ngFor="let v of brands" [value]="v.manufacturer_id">
														{{v.name}}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
										<div class="col-xs-12 col-md-3 col-3">
											<mat-form-field appearance="outline">
												<mat-label>Categories</mat-label>
												<mat-select formControlName="category" multiple appSelectAll>
													<mat-option *ngFor="let v of categories" [value]="v.categoryid">
														{{v.categoryid }} - {{v.categorydescription}}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
										<div class="col-xs-12 col-md-3 col-3">
											<mat-form-field appearance="outline">
												<mat-label>Product Lines</mat-label>
												<mat-select formControlName="prodline" multiple appSelectAll>
													<mat-option *ngFor="let v of productlines" [value]="v.line_field">
														{{v.line_description}}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
										<div class="col-xs-12 col-md-3 col-3">
											<mat-form-field appearance="outline">
												<mat-label>Date From</mat-label>
												<input matInput [matDatepicker]="pickerFrom" formControlName="datefrom">
												<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
												<mat-datepicker #pickerFrom></mat-datepicker>
											</mat-form-field>
										</div>
										<div class="col-xs-12 col-md-3 col-3">
											<mat-form-field appearance="outline">
												<mat-label>Date To</mat-label>
												<input matInput [matDatepicker]="pickerTo" formControlName="dateto">
												<mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
												<mat-datepicker #pickerTo></mat-datepicker>
											</mat-form-field>
										</div>
										<div class="col-xs-12 col-md-3 col-3">
											<span *ngIf="sending">
												<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
													<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
												</svg>
											</span>
											<div class="ActionButtons" *ngIf="!sending">
												<button mat-raised-button class="btn-success" (click)="$event.preventDefault();exportXls()">
													<i class="fa fa-file-excel-o"></i> XLS
												</button>
												<button mat-raised-button color="warn" (click)="$event.preventDefault();exportPdf()">
													<i class="fa fa-file-pdf-o"></i> PDF
												</button>
												<button mat-raised-button color="accent" (click)="tophundred()">
													<mat-icon>refresh</mat-icon>
												</button>
											</div>
										</div>
									</div>
								</div>
							</form>
							<div #print_table>
								<table class="table table-striped table-bordered table-hover table-fixed">
									<thead>
										<tr>
											<th>Item Number</th>
											<th>Description</th>
											<th>Sales Total ($)</th>
											<th>Sales Total (Qty)</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let r of sortedReportResults">
											<td>{{ r.stockid }}</td>
											<td>{{ r.description }}</td>
											<td>{{ r.salestotal | currency }}</td>
											<td>{{ r.qtytotal | number }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>